import React, { useEffect, useState } from 'react';
import './Countries.css'

const Countries = () => {
    const [countries, setCountries] = useState([])
    useEffect(() => {
        fetch('https://restcountries.com/v3.1/all')
            .then(res => res.json())
            .then(data => setCountries(data))
    }, [])
    return (
        <div>
            <h1>Visiting All Countries in the world!!!</h1>
            <h3>We Have total {countries.length} Countries</h3>
            <div className="countries">
                {
                    countries.map(country => <Country country={country} key={country.cca3}></Country>)
                }
            </div>
        </div>
    );
};

const Country = (props) => {
    const { name, capital, area, population, flags } = props.country;
    return (
        <div className='country'>
            <h3>{name.common}</h3>
            <p>Capital: {capital}</p>
            <img src={flags.png} alt="" />
            <p>Total Area: {area}</p>
            <p>Total Population: {population}</p>
        </div>
    )
}

export default Countries;